import request from 'superagent';

import { getCustomerData } from 'utils/user';
import { CUSTOMERS_URL } from 'constants/Jaws';
import { premiumUserGroup } from '../constants/UserGroups';

/**
 * If an account contains isSelected=true, return that one,
 * otherwise return default account.
 */
export function getSelectedAccount(customer) {
  if (!customer) {
    return null;
  }

  const accounts = customer.get('accounts');
  if (!accounts) {
    return null;
  }

  // Get selected account
  let selectedAccount = accounts.find(account => !!account.get('isSelected'));

  // No account is currently selected - use account from last session
  if (!selectedAccount && window.localStorage) {
    const lastActiveAccount = localStorage.getItem('lastActiveAccount');

    selectedAccount = accounts.find(account => {
      return account.get('customerId') === lastActiveAccount;
    });
  }

  // Fallback to master account
  return (
    selectedAccount || accounts.find(account => !!account.get('masterAccount'))
  );
}

/**
 * Get customer number for the currently selected account.
 *
 * When viewing portfolios and inventory, you want to view the account you
 * have selected, even if you are in a power of attourney situation.
 *
 * When trading, you want validation and redemptions to happen against
 * the account you have selected, even if you are in a power of attourney
 * situation.
 */
export function getCustomerNumber(user) {
  if (!user) {
    throw new Error('User.getCustomerNumber: user was ' + user);
  }

  const customerData = getCustomerData(user);

  if (!customerData) {
    return null;
  }

  const selectedAccount = getSelectedAccount(customerData);

  return selectedAccount ? selectedAccount.get('customerNumber') : null;
}

export function getAccountByVpsAccount(customer, vpsAccount) {
  return customer
    .get('accounts')
    .find(account => account.get('vpsAccountNo') === vpsAccount);
}

export function getAvailableVolume(customerNumber, customerId, ticker, sector) {
  return request.get(
    `${CUSTOMERS_URL}/${customerNumber}/exchange/${sector}/depot/` +
      `${customerId}/available-volume/${ticker}`,
  );
}

export function getIsPremiumAccount(selectedAccount) {
  return (
    selectedAccount &&
    premiumUserGroup.includes(selectedAccount.get('customerGroup'))
  );
}
